import React, { ReactElement, useContext } from 'react';
import { FilterContext } from './filter-service';

const DEFAULT_CAPTION = 'Load more';

const LoadMore = ({ onClick = null, caption }: iLoadMore): ReactElement | null => {
    const {
        isLoading,
        isFailedLoading,
        pagination: { page, nextUrl },
        setFilter,
        loadMoreBtn,
    } = useContext(FilterContext);
    const _onClick = (): void => {
        setFilter({ page: page + 1 }, true);
        if (onClick !== null) onClick();
    };
    const needLoadMore = (!isFailedLoading && nextUrl !== '' && nextUrl !== null) || loadMoreBtn;
    return needLoadMore ? (
        <div className="load-more">
            <button
                className="btn news-cards__btn"
                type="button"
                onClick={_onClick}
                disabled={isLoading || isFailedLoading}
            >
                {caption || DEFAULT_CAPTION}
            </button>
        </div>
    ) : null;
};

interface iLoadMore {
    caption?: string;
    onClick?: CallableFunction | null;
    loadMore?: boolean;
}

export { LoadMore };
